import Vue from 'vue';

import AppComponent from './app.component';
import {filters} from './filters';
import vuetify from './plugins/vuetify';
import router from './router';

Vue.config.productionTip = false;

import './components';
import './options';
import './plugins';
import i18n from './plugins/i18n';

new Vue({
    router,
    // store,
    vuetify,
    filters,
    i18n,
    render: h => h(AppComponent),
}).$mount('#app');
